import { createSlice } from "@reduxjs/toolkit";

const storedBrand = localStorage.getItem("selected-brand") || "equity_edge";

const initialState = {
  selectedBrand: {
    brand: storedBrand,
    value: storedBrand === "crypto_edge",
  },
};

const brandSlice = createSlice({
  name: "brand",
  initialState,
  reducers: {
    TOGGLE_Brand: (state, action) => {
      const newBrand = action.payload;
      state.selectedBrand = {
        brand: newBrand,
        value: newBrand === "crypto_edge",
      };
      localStorage.setItem("selected-brand", newBrand);
    },
    PURGE_Brand: (state) => {
      state.selectedBrand = {
        brand: "equity_edge",
        value: false,
      };
      localStorage.removeItem("selected-brand");
    },
  },
});

export const { TOGGLE_Brand, PURGE_Brand } = brandSlice.actions;
export default brandSlice.reducer;
